import styled, { css } from 'styled-components';

export const ButtonsWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};
  `,
);
